import { FORMAT_TYPES, MEDIA_EXTENSIONS, FORMAT_M3U8 } from '../constants';

/**
 * Resolve the mime type from a file extension
 *
 * @param {string} ext A file extension
 *
 * @return {string}
 */
export function getMimeFromExtension(ext) {
  return FORMAT_TYPES[ext] && FORMAT_TYPES[ext][0] || false;
}

/**
 * Checks if a file extension belongs to an audio file
 *
 * @param {string} ext A file extension
 *
 * @return {boolean}
 */
export function isAudioExtension(ext) {
  return MEDIA_EXTENSIONS.indexOf(ext) !== -1;
}

/**
 * Checks if the mime type is an HLS mime type
 *
 * @param {string} mime An audio mime type
 *
 * @return {boolean}
 */
export function isHlsMimeType(mime) {
  return FORMAT_TYPES[FORMAT_M3U8].indexOf(mime) !== -1;
}